module.exports = __webpack_public_path__ + "img/logo.d9583e84.png";